namespace TabAurous.Inventory {
    export interface ConvertToWIPItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        CalcUnitId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        UnitRate: Serenity.DecimalEditor;
        StoneRate: AmountEditor;
        OtherRate: AmountEditor;
        UnitLabour: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Line_No: Serenity.StringEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        HasBom: Serenity.BooleanEditor;
        NetWeight: WeightEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: WeightEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: WeightEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: WeightEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: WeightEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        DepartmentId: Serenity.IntegerEditor;
        Remarks: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: ConvertToWIPBOMEditor;
    }

    export class ConvertToWIPItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.ConvertToWIPItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ConvertToWIPItemsForm.init)  {
                ConvertToWIPItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonProductSizeLookup;
                var w5 = StoneSieveLookup;
                var w6 = WeightEditor;
                var w7 = s.DecimalEditor;
                var w8 = AmountEditor;
                var w9 = s.BooleanEditor;
                var w10 = s.DateEditor;
                var w11 = s.ImageUploadEditor;
                var w12 = ConvertToWIPBOMEditor;

                Q.initFormType(ConvertToWIPItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'RefNo', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'DesignCode', w0,
                    'AttributeId', w0,
                    'ProductTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'ProductSizeId', w4,
                    'MetalId', w2,
                    'Attribute', w0,
                    'CalcUnitId', w2,
                    'KaratId', w2,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w5,
                    'GroupSieveId', w5,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'Pieces', w1,
                    'Weight', w6,
                    'UnitRate', w7,
                    'StoneRate', w8,
                    'OtherRate', w8,
                    'UnitLabour', w7,
                    'NetAmount', w7,
                    'GrossAmount', w7,
                    'CCNetAmount', w7,
                    'CCGrossAmount', w7,
                    'Line_No', w0,
                    'HSN', w2,
                    'TaxCode', w2,
                    'HasBom', w9,
                    'NetWeight', w6,
                    'DiamondPieces', w1,
                    'DiamondWeight', w6,
                    'StonePieces', w1,
                    'StoneWeight', w6,
                    'OtherPieces', w1,
                    'OtherWeight', w6,
                    'MetalAmount', w7,
                    'DiamondAmount', w7,
                    'StoneAmount', w7,
                    'OtherAmount', w7,
                    'CalcOnId', w2,
                    'UnitCost', w7,
                    'DiscountPer', w7,
                    'Discount', w7,
                    'WstPer', w7,
                    'WstWt', w6,
                    'Purity', w7,
                    'PureWeight', w6,
                    'DepartmentId', w1,
                    'Remarks', w0,
                    'IsDisabled', w9,
                    'ServerDate', w10,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w10,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'ImageName', w11,
                    'BOMDetails', w12
                ]);
            }
        }
    }
}
